<template>
  <section class="content">
    <div v-if="!termsAccepted">
      <div class="modal-dialog">
        <form class="modal-content">
          <div class="modal-header">
            <h4 id="forgot_ModalLabel" class="modal-title"><i class="fa fa-bullhorn mr-5"></i>Hinweis</h4>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger">
              <h4><i class="icon fa fa-warning"></i> Achtung!</h4>
              <p>Um die Direktverkaufsfunktion zu aktivieren, müssen Sie den <a class="" :href="filePath" target="_blank"><strong>Allgemeinen Geschäftsbedingungen</strong></a> zustimmen.</p>
            </div>
            <label id="acceptLabel">
              <input id="acceptAGB" type="checkbox" v-model="acceptCheck"> Hiermit stimme ich dem Angebot sowie den Allgemeinen Geschäftsbedingungen für die Qualibet-Lizenz für Direktverkäufe zu.
            </label>
          </div>
          <div class="modal-footer">
            <button v-if="acceptCheck" id="acceptBtn" type="button" class="btn btn-success pull-left" @click="setAcceptedStatus()"><i class="fa fa-check mr-5"></i>Zustimmen</button>
            <a href="/" type="button" class="btn btn-outline"><i class="fa fa-times mr-5"></i>Abbrechen</a>
          </div>
        </form>
      </div>
    </div>
    <div v-else>
      <div id="directSalesAccepted" class="callout callout-success">
        <p>Sie haben den <a class="" :href="filePath" target="_blank">Allgemeinen Geschäftsbedingungen</a> zum Direktverkauf am {{acceptedDate}} zugestimmt.</p>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="nav-tabs-custom no-margin">
            <ul class="nav nav-tabs">
              <li class="active"><a href="#settings" data-toggle="tab" aria-expanded="false">Einstellungen</a></li>
            </ul>
          </div>
          <div class="tab-content">
            <div class="tab-pane active" id="settings">
              <div class="row">
                <div class="col-xs-12">
                  <div class="box box-primary">
                    <div class="box-body">
                      <h5 class="mb-10"><i class="fa fa-cogs text-muted mr-5"></i>Gaxsys Konfiguration:</h5>
                      <div class="margin"></div>
                      <div class="row">
                        <div class="col-sm-12 col-lg-4"></div>
                        <div class="col-sm-12 col-lg-8">
                          <p>
                            Bitte geben Sie hier Ihre Gaxsys Konfigurationsdaten ein.<br>
                            <span class="text-warning small">Bitte achten Sie auf Korrektheit, bei falschen Angaben ist keine Kommunikation zu Gaxsys möglich.</span>
                          </p>
                          <hr>
                          <div class="form-group">
                            <label>Benutzername:</label>
                            <input type="text" v-model="config.username" class="form-control" aria-required="true" aria-invalid="false">
                          </div>
                          <div class="form-group">
                            <label>Kennwort:</label>
                            <input type="password" v-model="config.password" class="form-control" aria-required="true" aria-invalid="false">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="box-footer">
                      <button @click="postPutGaxsysData()" class="btn btn-success btn-lg pull-right"><i class="fa fa-save mr-5"></i>Einstellungen speichern</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Gaxsys',
  data () {
    return {
      termsAccepted: 1,
      acceptedDate: '',
      filePath: '',
      acceptCheck: 0,
      needUpdate: 0,
      config: {
        'username': '',
        'password': '',
        'isActive': 0
      },
    }
  },
  methods: {
    getAcceptedStatus () {
      API.get(`directsales/terms/gaxsys`, {})
        .then(res => {
          this.termsAccepted = res.data.termsAccepted
          this.acceptedDate = res.data.acceptedDate
          if (this.termsAccepted === 1) {
            this.getGaxsysData()
          }
        })
    },
    getGaxsysData () {
      API.get(`directsales/gaxsys/configuration`, {})
        .then(res => {
          this.config = res.data
          if (this.config.username !== '' || this.config.password !== '') {
            this.needUpdate = 1
          }
        })
    },
    postPutGaxsysData () {
      if (this.needUpdate) {
        API.put('directsales/gaxsys/configuration', {'username': this.config.username, 'password': this.config.password, 'isActive': this.config.isActive})
          .then(response => {
            location.reload()
          })
      } else {
        API.post('directsales/gaxsys/configuration', {'username': this.config.username, 'password': this.config.password, 'isActive': this.config.isActive})
          .then(response => {
            location.reload()
          })
      }
    },
    getFilePath () {
      API.get(`directsales/file/gaxsys/terms`, {})
        .then(res => {
          this.filePath = res.data.path
        })
    },
    setAcceptedStatus () {
      API.post('directsales/terms/gaxsys', {termsAccepted: 1})
        .then(response => {
          this.termsAccepted = 1
          this.getGaxsysData()
        })
    },
  },
  mounted () {
    this.getAcceptedStatus()
    this.getFilePath()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Directsale/GaxsysView.vue